import type React from 'react'
import { GPlusIcon, HomestarsIcon, HouzzIcon, TiktokIcon, XIcon, YelpIcon } from '@paintscout/ui'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import PinterestIcon from '@material-ui/icons/Pinterest'
import TwitterIcon from '@material-ui/icons/Twitter'
import YouTubeIcon from '@material-ui/icons/YouTube'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
import PublicIcon from '@material-ui/icons/Public'

export interface SocialLinkType {
  label: string
  Icon: React.ComponentType<{ className?: string }>
  /** prepended to `href` when rendering (v1-parity for phone/email, which store a bare number/address) */
  prefix?: string
}

/**
 * The full set of networks the v1 "Socials" block supported, plus v2's original
 * "Twitter" (kept for existing saved blocks) and "Custom". `label` is the value
 * stored in `fields.links[].label` and is the shared key used by both
 * SocialLinksBlock (render) and SocialLinksOptions (edit), and by convert-socials.ts
 * (v1 `icon` key -> v2 `label`).
 */
export const socialLinkTypes: SocialLinkType[] = [
  { label: 'Facebook', Icon: FacebookIcon },
  { label: 'Instagram', Icon: InstagramIcon },
  { label: 'LinkedIn', Icon: LinkedInIcon },
  { label: 'Pinterest', Icon: PinterestIcon },
  { label: 'Twitter', Icon: TwitterIcon },
  { label: 'X', Icon: XIcon },
  { label: 'YouTube', Icon: YouTubeIcon },
  { label: 'TikTok', Icon: TiktokIcon },
  { label: 'Yelp', Icon: YelpIcon },
  { label: 'Houzz', Icon: HouzzIcon },
  { label: 'Homestars', Icon: HomestarsIcon },
  { label: 'Google', Icon: GPlusIcon },
  { label: 'WhatsApp', Icon: WhatsAppIcon },
  { label: 'Phone', Icon: PhoneIcon, prefix: 'tel:' },
  { label: 'Email', Icon: EmailIcon, prefix: 'mailto:' },
  { label: 'Custom', Icon: PublicIcon }
]

export const socialLinkTypesByLabel: { [label: string]: SocialLinkType } = Object.fromEntries(
  socialLinkTypes.map((type) => [type.label, type])
)
